export const API_ADMIN_GET_ALL_SERVIPAY_TERMINAL = 'API_ADMIN_GET_ALL_SERVIPAY_TERMINAL';
export const API_ADMIN_GET_ALL_SERVIPAY_TERMINAL_SUCCESS = 'API_ADMIN_GET_ALL_SERVIPAY_TERMINAL_SUCCESS';
export const API_ADMIN_GET_ALL_SERVIPAY_TERMINAL_FAIL = 'API_ADMIN_GET_ALL_SERVIPAY_TERMINAL_FAIL';

export const API_ADMIN_GET_SERVIPAY_TERMINAL = 'API_ADMIN_GET_SERVIPAY_TERMINAL';
export const API_ADMIN_GET_SERVIPAY_TERMINAL_SUCCESS = 'API_ADMIN_GET_SERVIPAY_TERMINAL_SUCCESS';
export const API_ADMIN_GET_SERVIPAY_TERMINAL_FAIL = 'API_ADMIN_GET_SERVIPAY_TERMINAL_FAIL';

export const API_ADMIN_PATCH_SERVIPAY_TERMINAL = 'API_ADMIN_PATCH_SERVIPAY_TERMINAL'
export const API_ADMIN_PATCH_SERVIPAY_TERMINAL_SUCCESS = 'API_ADMIN_PATCH_SERVIPAY_TERMINAL_SUCCESS'
export const API_ADMIN_PATCH_SERVIPAY_TERMINAL_FAIL = 'API_ADMIN_PATCH_SERVIPAY_TERMINAL_FAIL'

export const API_ADMIN_POST_SERVIPAY_TERMINAL = 'API_ADMIN_POST_SERVIPAY_TERMINAL'
export const API_ADMIN_POST_SERVIPAY_TERMINAL_SUCCESS = 'API_ADMIN_POST_SERVIPAY_TERMINAL_SUCCESS'
export const API_ADMIN_POST_SERVIPAY_TERMINAL_FAIL = 'API_ADMIN_POST_SERVIPAY_TERMINAL_FAIL'

export const API_ADMIN_DELETE_SERVIPAY_TERMINAL = 'API_ADMIN_DELETE_SERVIPAY_TERMINAL'
export const API_ADMIN_DELETE_SERVIPAY_TERMINAL_SUCCESS = 'API_ADMIN_DELETE_SERVIPAY_TERMINAL_SUCCESS'
export const API_ADMIN_DELETE_SERVIPAY_TERMINAL_FAIL = 'API_ADMIN_DELETE_SERVIPAY_TERMINAL_FAIL'

export const RESET_SAMPLE_TYPE = 'RESET_SAMPLE_TYPE';

export const ADMIN_INIT_NEW_SERVIPAY_TERMINAL = 'ADMIN_INIT_NEW_SERVIPAY_TERMINAL';
export const ADMIN_RESET_FOCUS_SERVIPAY_TERMINAL = 'ADMIN_RESET_FOCUS_SERVIPAY_TERMINAL';
